export default __webpack_public_path__ + "static/media/tomate.c02338e7.jpeg";